import "./FourOhFourPage.scss";

import {
  SUPPORT_EMAIL,
  SUPPORT_EMAIL_MAILTO,
} from "shared/utils/siteConstants";

import LinkButton from "../LinkButton";

const FourOhFourPage = ({
  status = "404",
  message = "Page Not Found",
}: {
  status?: string;
  message?: string;
}) => {
  return (
    <div id="FourOhFour">
      <div>
        <h2>{status}</h2>
        <h4>{message}</h4>
        <div>
          <p>
            <a href="/">Click here to return to the homepage</a> or{" "}
            <LinkButton
              onClick={() => {
                window.history.back();
              }}
            >
              go back to the previous page.
            </LinkButton>
          </p>
          <p>
            Please contact <a href={SUPPORT_EMAIL_MAILTO}>{SUPPORT_EMAIL}</a> if
            you think you've reached this page in error.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FourOhFourPage;
